<template>
  <el-container direction="vertical" style="margin: 5vh 5vw">
    <process-log :isVisible.sync="showModal" :recordSelected="recordSelected" />
    <PdfModal :isVisible.sync="dateModal" @makePdf="makePdf" />
    <div class="header">
      <h2>Package: {{ currentJobName }}</h2>
    </div>
    <div style="display: flex; align-items: center">
      <el-breadcrumb
        separator-class="el-icon-arrow-right"
        style="margin: 5px 0 35px 0"
      >
        <el-breadcrumb-item :to="{ path: `/servers/${instanceId}/packages` }"
          >Packages</el-breadcrumb-item
        >
        <el-breadcrumb-item>History</el-breadcrumb-item>
      </el-breadcrumb>
      <div style="flex-grow: 1"></div>
      <!-- <el-button
        class="button"
        @click="dateModal = true"
        style="
          text-align: center;
          padding: 18px;
          width: 125px;
          height: 40px;
          float: right;
          line-height: 15%;
        "
      >
        Download PDF</el-button
      > -->
    </div>

    <!-- <el-input v-model="filter" placeholder="Type to search" style="width: 30%; margin-bottom: 12px" /> -->
    <slider>
      <template #table>
        <jobTable
          v-if="itemsToShow.length > 0"
          ref="jobTable"
          @selectJobHistory="selectJobHistory"
          @selectActivityHistory="selectActivityHistory"
          @expandCollapseJob="expandCollapseJob"
          :itemsToShow="itemsToShow"
          :tableFormat="tableFormat"
        />
      </template>
      <template #details>
        <jobDetails
          ref="jobDetails"
          @tabClicked="tabClicked"
          @setShowModal="setShowModal"
          :showModal="showModal"
          :itemsToShow="itemsToShow"
          :activeTab="activeTab"
          :activeRecord="activeRecord"
          :historyDetails="historyDetails"
          :logData="logData"
        />
      </template>
    </slider>
  </el-container>
</template>

<script>
import ProcessLog from "../components/modals/ProcessLog";
import PdfModal from "../components/modals/DatePdf";
import JobService from "../services/JobService";
import jobDetails from "../components/JobHistoryDetails.vue";
import jobTable from "../components/JobTable.vue";
import TaskService from "../services/TaskService";
import moment from "moment-timezone";
import { mapState } from "vuex";
import slider from "../components/Draggable.vue";
import Helper from "../utilities/Helper";
import store from "../store/store";

export default {
  data() {
    return {
      showModal: false,
      dateModal: false,
      items: [],
      itemsToShow: [],
      filter: null,
      activeTab: "Details",
      activeRecord: {},
      historyDetails: {},
      logData: [],
      tableFormat: [],
      filterResultList: [],
      filterRunByList: [],
      recordSelected: null,
      pendingHistories: [],
      pendingIds: [],
      timer: "",
      timezone:
        process.env.VUE_APP_SERVER_TIMEZONE ||
        Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
  },
  components: { ProcessLog, jobDetails, slider, jobTable, PdfModal },
  watch: {
    filter(value) {
      let filter = value.toLowerCase();
      this.itemsToShow = this.items.filter((item) => {
        return JSON.stringify(item).toLowerCase().includes(filter);
      });
    },
  },
  computed: {
    ...mapState(["currentJobName", "instanceId", "jobId", "isUserLoggedIn"]),
  },
  methods: {
    handleError: Helper.handleError,
    expandCollapseJob(row, expandedRows) {
      if (
        expandedRows.length > 0 &&
        document.getElementsByClassName("el-table__expand-icon--expanded")
          .length > 0
      ) {
        document
          .getElementsByClassName("el-table__expand-icon--expanded")[0]
          .click();
      }

      this.$refs.jobTable.$refs.jobHistoryTable.setCurrentRow(row);
      if (this.$refs.jobTable.$refs.taskHistoryTable) {
        this.$refs.jobTable.$refs.taskHistoryTable.setCurrentRow();
      }

      this.activeRecord = row;
      this.historyDetails = {};
    },
    async combineSingleCubeDims() {
      const sourceViewDims = this.historyDetails.source.taskHistoryDims.slice();
      const targetViewDims = this.historyDetails.target.taskHistoryDims.slice();

      const response = await TaskService.getCubeDims({
        cubeName: this.historyDetails.target.taskHistoryCube.name,
        instanceId: this.instanceId,
      });
      const targetCubeDims = response.data.dims.value;

      sourceViewDims.forEach((sourceDim) => {
        const foundInTargetViewDims = targetViewDims.find(
          (dim) => dim.name === sourceDim.name
        );
        if (!foundInTargetViewDims) {
          const foundInTargetCubeDims = targetCubeDims.find(
            (dim) => dim.Name === sourceDim.name
          );
          if (foundInTargetCubeDims) {
            const index = sourceViewDims.indexOf(sourceDim);
            this.historyDetails.target.taskHistoryDims[index] = sourceDim;
          }
        } else {
          const index = sourceViewDims.findIndex(
            (dim) => dim.name === foundInTargetViewDims.name
          );
          this.historyDetails.target.taskHistoryDims[index] =
            foundInTargetViewDims;
        }
      });
    },
    combineMultipleCubesDims() {
      const sourceViewDims = this.historyDetails.source.slice();
      const targetViewDims = this.historyDetails.target.slice();

      sourceViewDims.forEach((sourceDim) => {
        const found = targetViewDims.find((dim) => dim.name === sourceDim.name);
        if (!found) {
          const index = sourceViewDims.indexOf(sourceDim);
          this.historyDetails.target[index] = sourceDim;
        } else {
          const index = sourceViewDims.findIndex(
            (dim) => dim.name === found.name
          );
          this.historyDetails.target[index] = found;
        }
      });
    },
    async selectJobHistory(row) {
      if (row) {
        if (this.$refs.jobTable.$refs.taskHistoryTable) {
          this.$refs.jobTable.$refs.taskHistoryTable.setCurrentRow();
        }
        this.activeRecord = row;
        this.activeRecord.type = "Job";
        this.historyDetails = {};

        this.logData = [];
        const logResponse = await JobService.getLog({
          jobHistoryId: this.activeRecord.id,
        });
        for (const record of logResponse.data.log) {
          record.createdAt = moment(record.createdAt)
            .tz(this.timezone)
            .format("h:mm:ss A on LL");
          this.logData.push(record);
        }
      }
    },
    async selectActivityHistory(row) {
      if (row) {
        const loading = this.$loading({
          lock: true,
          //text: "Working",
          background: "rgba(0, 0, 0, 0.3)",
        });
        try {
          this.$refs.jobTable.$refs.jobHistoryTable.setCurrentRow();
          this.activeRecord = row;

          if (row.type === "Task") {
            const response = await TaskService.getHistoryDetails({
              taskHistoryId: row.taskHistory.id,
            });
            const taskHistoryDetails = response.data.taskHistoryDetails;

            if (this.activeRecord.taskHistory.source === "Single Cube") {
              this.historyDetails = {
                source:
                  taskHistoryDetails[0].taskHistoryCube.type === "source"
                    ? taskHistoryDetails[0]
                    : taskHistoryDetails[1],
                target:
                  taskHistoryDetails[0].taskHistoryCube.type === "target"
                    ? taskHistoryDetails[0]
                    : taskHistoryDetails[1],
              };

              if (this.activeRecord.target !== "File")
                await this.combineSingleCubeDims();
            } else if (
              this.activeRecord.taskHistory.source === "Multiple Cubes"
            ) {
              this.historyDetails = {
                source: [],
                target: [],
              };

              for (let i = 0; i < taskHistoryDetails.length; i++) {
                if (taskHistoryDetails[i].type === "source") {
                  this.historyDetails.source.push(taskHistoryDetails[i]);
                } else if (taskHistoryDetails[i].type === "target") {
                  this.historyDetails.target.push(taskHistoryDetails[i]);
                }
              }

              this.combineMultipleCubesDims();
            } else if (this.activeRecord.taskHistory.source === "Value") {
              this.historyDetails = {
                target: taskHistoryDetails[0],
              };
            }
          }

          this.logData = [];
          const logResponse = await JobService.getActivityLog({
            jobHistoryActivityId: this.activeRecord.id,
          });
          for (const record of logResponse.data.log) {
            record.createdAt = moment(record.createdAt)
              .tz(this.timezone)
              .format("h:mm:ss A on LL");
            this.logData.push(record);
          }
        } catch (err) {
          this.handleError(err, this, this.instanceId);
        } finally {
          loading.close();
        }
      }
    },
    async getHistory() {
      const loading = this.$loading({
        lock: true,
        //text: "Working",
        background: "rgba(0, 0, 0, 0.3)",
      });
      try {
        const response = await JobService.getHistory({
          jobId: this.jobId,
        });
        //uses sets to avoid repeated values for the filter options
        let setOfResults = new Set();
        let setOfRunBy = new Set();
        this.items = await Promise.all(
          response.data.histories.map(async (history) => {
            //gets all the data details for a job.
            const jobHistory = history.jobHistory;

            jobHistory.result = history.jobHistory.result;
            jobHistory.runBy = history.runBy;
            jobHistory.jobName = this.currentJobName;
            jobHistory.duration =
              moment(jobHistory.updatedAt).diff(
                moment(jobHistory.createdAt),
                "seconds"
              ) + " seconds";
            jobHistory.createdAt = moment(history.createdAt)
              .tz(this.timezone)
              .format("h:mm:ss A on LL");

            const activityResponse = await JobService.getHistoryActivities({
              jobHistoryId: jobHistory.id,
            });
            jobHistory.activities = activityResponse.data.activityHistories;
            setOfResults.add(jobHistory.result);
            setOfRunBy.add(jobHistory.runBy);
            if (jobHistory.result === "Pending") {
              this.pendingHistories.push(jobHistory);
              this.pendingIds.push(jobHistory.id);
            }

            return jobHistory;
          })
        );
        //converts sets to arrays
        this.filterRunByList = Array.from(setOfRunBy);
        this.filterResultList = Array.from(setOfResults);
        //sorts array for the filter options
        this.filterRunByList.sort();
        this.filterResultList.sort();
        //put the filter options into objs that would be accepted to it
        this.filterRunByList = this.filterRunByList.map((name) => {
          return { value: name, text: name };
        });
        this.filterResultList = this.filterResultList.map((name) => {
          return { value: name, text: name };
        });

        this.itemsToShow = this.items;
        this.itemsToShow.sort(this.sortDate).reverse();
        if (this.itemsToShow.length > 0) {
          this.activeRecord = this.itemsToShow[0];
        }
        //table format is for how the table will look like and shows if it is filter
        //and sorted and which value it is
        this.tableFormat = [
          {
            prop: "result",
            label: "Result",
            filterOption: this.filterResultList,
            filterMethod: this.filterJobResult,
            filterPlacement: "bottom-end",
          },
          {
            prop: "createdAt",
            label: "Started At",
            sortMethod: this.sortDate,
          },
          {
            prop: "duration",
            label: "Duration",
            sortMethod: this.sortDuration,
          },
          {
            prop: "runBy",
            label: "Run By",
            filterOption: this.filterRunByList,
            filterMethod: this.filterRunBy,
            filterPlacement: "bottom-end",
          },
        ];
      } catch (err) {
        this.handleError(err, this, this.instanceId);
      } finally {
        loading.close();
      }
    },
    async tabClicked(tab) {
      if (tab.name === "Log") {
        await this.updateLog();
      }
    },
    async updateLog() {
      this.logData = [];
      let logResponse = [];
      if (this.activeRecord.type === "Job") {
        logResponse = await JobService.getLog({
          jobHistoryId: this.activeRecord.id,
        });
      } else {
        logResponse = await JobService.getActivityLog({
          jobHistoryActivityId: this.activeRecord.id,
        });
      }
      for (const record of logResponse.data.log) {
        record.createdAt = moment(record.createdAt)
          .tz(this.timezone)
          .format("h:mm:ss A on LL");
        this.logData.push(record);
      }
    },
    /**
     * Make backend call to auto refresh jobs list
     * @async
     * @function
     */
    async refreshJob() {
      try {
        // Check if all Jobs completed
        if (this.pendingHistories.length === 0) {
          this.cancelAutoUpdate();
          return;
        }
        // Check if user is on the log tab of pending job task
        //if (this.activeRecord.result === 'Pending') {
        if (
          this.activeRecord.type === "Task" ||
          this.activeRecord.type === "Process"
        ) {
          if (
            this.activeTab === "Log" &&
            this.activeRecord.result === "Pending"
          ) {
            await this.renderLog();
          }
        }
        // Check if user is on log tab of pending job
        else if (
          this.pendingIds.indexOf(this.activeRecord.id) != -1 &&
          this.activeTab === "Log"
        ) {
          await this.renderLog();
        }
        // Get all finished job histories
        const response = await JobService.getHistoryResults();
        const finishedHistories = response.data.jobHistories;
        const finishedTotal = finishedHistories.length;
        let historyIndex;
        let resultJobFilter = new Set();
        for (let i = 0; i < finishedTotal; i++) {
          historyIndex = this.pendingIds.indexOf(finishedHistories[i].id);
          // Check if pending history is not in list of finished histories
          if (historyIndex != -1) {
            this.pendingHistories[historyIndex].result = finishedHistories[
              i
            ].result
              .replace(/[A-Z]/g, " $&")
              .trim();
            this.pendingHistories[historyIndex].duration =
              moment(finishedHistories[i].updatedAt).diff(
                moment(finishedHistories[i].createdAt),
                "seconds"
              ) + " seconds";

            this.pendingHistories.splice(historyIndex, 1); // Remove history from pending history list
            this.pendingIds.splice(historyIndex, 1);
            resultJobFilter.add(finishedHistories[i].result);
          }
        }

        if (resultJobFilter.size > 0) {
          //updates the filter of results if the result of the job changes
          this.filterResultList = Array.from(resultJobFilter);
          this.filterResultList.sort();
          this.filterResultList = this.filterResultList.map((name) => {
            return { value: name, text: name };
          });
          let newTableFormat = this.tableFormat.slice();
          newTableFormat[0] = {
            prop: "result",
            label: "Result",
            filterOption: this.filterResultList,
            filterMethod: this.filterJobResult,
            filterPlacement: "bottom-end",
          };
          this.tableFormat = newTableFormat;
        }
        await this.updateTasks();
      } catch (err) {
        this.cancelAutoUpdate();
        this.handleError(err, this, this.instanceId);
      }
    },
    /**
     * Makes backend call to update a job's task history
     * @async
     * @function
     */
    async updateTasks() {
      const pendingSize = this.pendingHistories.length;
      for (let i = 0; i < pendingSize; i++) {
        // Get task history for each pending job
        const activityResponse = await JobService.getHistoryActivities({
          jobHistoryId: this.pendingHistories[i].id,
        });
        // Update history's task history
        const activeId = this.activeRecord.id;
        this.pendingHistories[i].activities =
          activityResponse.data.activityHistories;

        if (
          this.activeRecord.type === "Task" ||
          this.activeRecord.type === "Process"
        ) {
          // Check if user has one of job's task history selected
          const isSelected = this.pendingHistories[i].activities.find(
            (activity) => {
              return activity.id === activeId;
            }
          );

          if (isSelected != undefined) {
            // Set selected row to what it was before
            this.$refs.jobTable.$refs.taskHistoryTable.setCurrentRow(
              isSelected
            );
          }
        }
      }
    },
    /**
     * Makes back end call to update the logs tab
     * @async
     * @function
     */
    async renderLog() {
      let container = this.$refs.logsTab;
      let scrollBottom = false;
      const currScroll = container.$el.scrollTop;
      // Check if user is scrolled all the way to the bottom
      if (
        currScroll + container.$el.clientHeight >=
        container.$el.scrollHeight
      ) {
        scrollBottom = true;
      }
      await this.updateLog();
      // Either scroll to the bottom or to where the user was previously scrolled to
      scrollBottom === true
        ? (container.$el.scrollTop = container.$el.scrollHeight)
        : (container.$el.scrollTop = currScroll);
    },
    async makePdf(dateRanges) {
      const loading = this.$loading({
        lock: true,
        //text: "Working",
        background: "rgba(0, 0, 0, 0.3)",
      });
      try {
        //gets date ranges from the modals
        let date1 = new Date(dateRanges[0]);
        let date2 = new Date(dateRanges[1]).setHours(23, 59, 59);
        //gets the table data to pass into the backend
        let filterData = this.$refs.jobTable.$refs.jobHistoryTable.tableData;
        //gets all of the filter options from the headers and sees if it is filtered
        let filterOptions =
          this.$refs.jobTable.$refs.jobHistoryTable.$refs.tableHeader.columns;
        let totalFilter = { result: [], startAt: [], duration: [], runBy: [] };
        //the columns are off by one because of the dropdown of the job
        for (let index = 1; index < filterOptions.length; index++) {
          //sees if there is a filter at the column then adds it based on the index
          if (filterOptions[index].filteredValue.length > 0) {
            for (let filterValue of filterOptions[index].filteredValue) {
              if (index == 1) {
                totalFilter.result.push(filterValue);
              } else if (index == 2) {
                totalFilter.startAt.push(filterValue);
              } else if (index == 3) {
                totalFilter.duration.push(filterValue);
              } else if (index == 4) {
                totalFilter.runBy.push(filterValue);
              }
            }
          }
        }
        //filters the table data based on the date from the modal then passes to the backend
        filterData = filterData.filter(
          (taskFilter) =>
            date1 - this.toFloatDate(taskFilter.createdAt) <= 0 &&
            date2 - this.toFloatDate(taskFilter.createdAt) >= 0
        );
        //reduces the filterData to only have ids and passes it forward
        let filterIds = filterData.map((data) => {
          return data.id;
        });
        JobService.getFilteredHistoryDetails(
          filterIds,
          totalFilter,
          store.state.userId,
          dateRanges
        );
      } catch (err) {
        this.handleError(err, this, this.instanceId);
      } finally {
        loading.close();
      }
    },
    /**
     * Cancels the auto update timer
     * @function
     */
    cancelAutoUpdate() {
      clearInterval(this.timer);
    },
    /**
     * The purpose: The purpose is to have a sorting algo for the custom sort.
     * @param {object} a is a object that has a duration
     * @param {object} b is a object that has a duration
     */
    sortDuration(a, b) {
      return (
        this.toFloatDuration(a.duration) - this.toFloatDuration(b.duration)
      );
    },
    toFloatDuration(num) {
      return parseFloat(num.replace(" seconds", ""));
    },
    /**
     * The purpose: The purpose is to have a sorting algo for the custom sort.
     * @param {object} a is a object that has a date
     * @param {object} b is a object that has a date
     */
    async setShowModal() {
      this.showModal = true;
    },
    sortDate(a, b) {
      return this.toFloatDate(a.createdAt) - this.toFloatDate(b.createdAt);
    },
    toFloatDate(num) {
      let date = new Date(num.split(" on ").join(" "));
      return date;
    },
    /**
     * The purpose: the filter method for the runBy table
     * @param {any} value
     * @param {obj} row
     */
    filterRunBy(value, row) {
      return row.runBy === value;
    },
    /**
     * The purpose: the filter method for the result table
     * @param {any} value
     * @param {obj} row
     */
    filterJobResult(value, row) {
      return row.result === value;
    },
    /**
     * The purpose: the filter method for the created at table
     * @param {any} value
     * @param {obj} row
     */
    filterDates(value, row) {
      let date = row.createdAt.split("on ")[1];
      date = date.split(" ");
      date = date[0] + " " + date[2];

      return date === value;
    },
  },
  created() {
    // Sets auto update for every 10 seconds
    this.timer = setInterval(this.refreshJob, 10000);
  },
  mounted() {
    if (!this.isUserLoggedIn) {
      this.$router.push({ name: "login" });
    } else if (!this.instanceId) {
      this.$router.push({ name: "servers" });
    } else {
      this.getHistory();
    }
  },
  beforeDestroy() {
    if (this.jobId) this.$store.dispatch("setJobId", null);
    if (this.currentJobName) this.$store.dispatch("setCurrentJobName", null);
  },
};
</script>

<style scoped>
.button {
  background-color: #b3282d;
  color: white;
  border-color: white;
  padding: 10px 15px;
}
.button:focus {
  background-color: #9a0f14;
  color: white;
  border-color: white;
  outline: none;
}
.button:hover {
  background-color: #9a0f14;
  color: white;
  border-color: white;
  outline: none;
}
.card {
  font-size: 14px;
  color: #606266;
}
.el-card :deep(.el-card__header) {
  background-color: #f0f0f0;
  padding: 10px 20px;
}
.el-card :deep(.el-card__body) {
  padding: 10px 20px;
}
.el-table :deep(.el-table__expanded-cell) {
  padding: 10px 50px;
}
</style>
